module.exports = __webpack_public_path__ + "static/media/youtube-clone.e26569a9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/youtube-clone.gif
// module id = 46
// module chunks = 0